import { SubHeader, SubHeaderActions } from '../../components/SubHeader';
import { useSummaryQueryContext } from './contexts/query';
import { CsvExportButton } from './CsvExportButton';

const displayContent = {
  pageTitle: 'Event summary',
};

const PageActions = () => {
  const { isError, isLoading } = useSummaryQueryContext();

  if (isError || isLoading) {
    return null;
  }

  return (
    <SubHeaderActions>
      <CsvExportButton />
    </SubHeaderActions>
  );
};

export const EventSummaryHeader = () => (
  <SubHeader actions={<PageActions />}>{displayContent.pageTitle}</SubHeader>
);
